let config

const maintenancemode = false;

const configlive = {
  mode: 'live',
  front_url: 'https://markii.gdq.se',
  base_url: 'https://api.gdq.se',
  report_url: 'https://reports.gdq.se',
  api_token: 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpZCI6MCwiZXhwIjoxNzkzNjk5MzEyfQ.RN9RffkIpmOrKsAjCyP6cmhPRLtzPzzXgRNzvVcxugk',
  maintenancemode,
  timeZone: 'Europe/Berlin'
}

const configtest = {
  mode: 'test',
  front_url: 'http://bjorn-ubuntu:8080',
  base_url: 'http://ubuntu-dbweb.local/gdq_api',
  report_url: 'http://ubuntu-dbweb.local/gdq_reports',
  api_token: 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpZCI6MCwiZXhwIjoxNzkzNjk5MzEyfQ.RN9RffkIpmOrKsAjCyP6cmhPRLtzPzzXgRNzvVcxugk',
  maintenancemode,
  timeZone: 'Europe/Berlin'
}

const configstage = {
  mode: 'stage',
  front_url: 'https://markii.test.gdq.se',
  base_url: 'https://api.test.gdq.se',
  report_url: 'https://reports.test.gdq.se',
  api_token: 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpZCI6MCwiZXhwIjoxNzkzNjk5MzEyfQ.RN9RffkIpmOrKsAjCyP6cmhPRLtzPzzXgRNzvVcxugk',
  maintenancemode,
  timeZone: 'Europe/Berlin'
}

config = configlive
const location = window.location.host

if (location.indexOf('.test.gdq.se') > 0) {
  config = configstage
}
if (location.indexOf('gdq.se') < 0) {
  config = configtest
}
export { config }
